import { Cpu, Menu } from "lucide-react";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { Sidebar } from "./Sidebar";

export function Layout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer whenever the route changes.
  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen bg-bg text-text">
      {/* Desktop sidebar — unchanged; hidden below md. */}
      <div className="hidden shrink-0 md:flex">
        <Sidebar />
      </div>

      {/* Mobile drawer + backdrop (md:hidden). */}
      {drawerOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setDrawerOpen(false)}
            aria-hidden
          />
          <div className="absolute left-0 top-0 h-full">
            <Sidebar onNavigate={() => setDrawerOpen(false)} />
          </div>
        </div>
      )}

      {/* `flex flex-col` on mobile (to stack the top bar above content);
          `md:block` restores the exact desktop main element. */}
      <main className="flex flex-1 flex-col overflow-y-auto md:block">
        {/* Mobile top bar with hamburger — hidden on desktop. Fixed height (h-14)
            so pages can compute a no-scroll viewport via calc(100dvh-3.5rem). */}
        <div className="flex h-14 shrink-0 items-center gap-3 border-b border-border bg-bg-surface px-4 md:hidden">
          <button
            type="button"
            onClick={() => setDrawerOpen(true)}
            className="-ml-1 rounded-md p-2 text-text-muted hover:bg-bg-elevated hover:text-text"
            aria-label="Open navigation menu"
          >
            <Menu size={22} />
          </button>
          <div className="flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-accent to-accent-hover">
              <Cpu size={16} className="text-bg" />
            </div>
            <span className="text-sm font-semibold">DroneTag</span>
          </div>
        </div>

        <Outlet />
      </main>
    </div>
  );
}
